import React, { lazy } from 'react';
const bonuses = [{
  title: 'Certificado de Finalización',
  description: 'Avalá tus conocimientos y dale más autoridad a tu perfil profesional.',
  image: 'https://cdn.magicpatterns.com/uploads/5tYNvVUogQAMKjaVFp1jkf/1.png'
}, {
  title: 'Protocolo para clientas con Microblading',
  description: 'Aprende a combinar técnicas para resultados hiperrealistas.',
  image: 'https://cdn.magicpatterns.com/uploads/6xr9HJZV6h1JbXALiVELN3/2.png'
}, {
  title: 'Plan de 30 días para conseguir clientas',
  description: 'Estrategia paso a paso para conseguir tus primeras clientas rápido.',
  image: 'https://cdn.magicpatterns.com/uploads/nTTQvrpkFKzGR6WeyAb1nj/3.png'
}, {
  title: 'Megapack de Contenido',
  description: 'Plantillas de Reels y fotos listas para usar en tus redes.',
  image: 'https://cdn.magicpatterns.com/uploads/6aSVP2toeYVGdmR3h1FtRj/4.png'
}, {
  title: 'Lista de Proveedores',
  description: 'Los mejores materiales al mejor precio para empezar con baja inversión.',
  image: 'https://cdn.magicpatterns.com/uploads/9hmJs9NBBQYS9YcdY6ogDx/5.png'
}];
export function BonusesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 md:py-12 px-4 bg-[#BC4FBF]" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <div className="inline-block bg-yellow-400 px-8 py-3 rounded-full font-black text-xl mb-6 text-[#9C16A3]" data-id="element-25">
            🎁 BONUS DE REGALO
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-[#FFFFFF]" data-id="element-26">
            ACCEDÉ AHORA CON 5 BONUS 🎁
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-27">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden cursor-pointer hover:scale-105 transition-transform duration-300 border-4 border-[#b026ff] shadow-[0_0_15px_rgba(176,38,255,0.5),0_0_30px_rgba(176,38,255,0.3)]" onClick={scrollToCompra} data-id="element-28">
              <div className="flex justify-center -mb-3 relative z-10 pt-4" data-id="element-29">
                <div className="bg-green-500 text-white px-5 py-2 rounded-full font-black text-sm tracking-wide shadow-[0_0_15px_rgba(34,197,94,0.6),0_0_30px_rgba(34,197,94,0.3)] animate-bounce" data-id="element-30">
                  🎁 GRATIS POR HOY
                </div>
              </div>
              <div className="px-4 pt-8 pb-4 flex flex-col items-center justify-center" data-id="element-31">
                <div className="font-black text-5xl mb-3 drop-shadow-[0_0_10px_rgba(34,197,94,0.5)] text-[#303030]" data-id="element-32">
                  #{index + 1}
                </div>
                <img src={bonus.image} alt={bonus.title} className="w-full max-w-[240px] h-auto object-contain drop-shadow-2xl" loading="lazy" data-id="element-33" />
              </div>
              <div className="p-6" data-id="element-34">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-35">
                  Bono {index + 1} — {bonus.title}
                </h3>
                <p className="text-gray-600" data-id="element-36">{bonus.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}